import AddressProofError from './AddressProofError';
class InvalidAddressProofStatus extends AddressProofError {
    constructor(options) {
        super('Address proof has invalid status', options);
    }
}
export default InvalidAddressProofStatus;
